import React, { useEffect, useState } from 'react';
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_kratos";
import useHttp from "../../../hook/use-http";
import ChartLoader from "./ChartLoader";
import WaterMark from "../DashboardMain_Kratos/WaterMark";
import NoTableData from "./NoTableData";
import NoData from './NoData';
import './CriticalCustom_Kratos.css';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import CommanBarTable_Kratos from './CommanBarTable_Kratos';

export default function CriticalMonthGraph({gloablfilter}) {

    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [topping, setTopping] = useState('CurrImb');
    const [totalMonthCount, setTotalMonthCount] = useState(0);
    const [monthWiseData, setMonthWiseData] = useState([]);
    const [labelData, setLabelData] = useState([]);
    const [finalBarData , setFinalBarData] = useState([]);
    const [clickedDate, setClickedDate] = useState('');
    const [popupData, setPopupData] = useState([]);

    const toppingChange = (e) =>{
        setTopping(e.target.value);
    }

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos_fleet/critcal_totalmonthcount", body: { filterdata: gloablfilter} }, critical_response)
    }, [gloablfilter, topping])

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos_fleet/critcal_monthcount", body: { filterdata: gloablfilter} }, monthWiseData_responce)
    }, [gloablfilter, totalMonthCount, topping])

    const critical_response = (data) =>{
        setTotalMonthCount(data.vehicleId.value)
    }

    const monthWiseData_responce = (data) =>{
        if (topping === 'CurrImb') {
            setFinalBarData(data.monthData)
            setLabelData(data.label)
        }else{
        let barData= []
        if(totalMonthCount !== 0){
            for (let i in data.monthData) {
                barData[i] = ((data.monthData[i]/totalMonthCount)*100).toFixed(2);
            }
        }
        setFinalBarData(barData)
        setMonthWiseData(data.monthData)
        setLabelData(data.label)
    }
    }
    
    const labels = labelData;
    const data = {
        labels,
        datasets: [
          {
            data: finalBarData ,
            backgroundColor: '#83A4CF',
            barThickness: 40,
          }
        ],
    };

  // const options = {
  //       scales: {
  //         x: {
  //           barPercentage: 0.2, // Adjust the value to decrease or increase the gap between bars
  //           categoryPercentage: 0.2,// Adjust the value to decrease or increase the gap between bars
  //         },
  //         y: {
  //           beginAtZero: true
  //         }
  //       },
  //       plugins: {
  //         legend: {
  //           display: false,
  //         },
  //         datalabels: {
  //           color: '#fff', // color of the data labels
  //           anchor: 'end', // position of the data labels
  //           align: 'start', // alignment of the data labels
  //           // rotation: 270,
  //           font: {
  //             weight: 'bold', // make the text bold
  //           },
          
  //         },
  //       },
  //       elements: {
  //         line: {
  //           tension: 0,
  //         },
  //       },
  //       layout: {
  //         padding: {
  //           left: 10,
  //           right: 10,
  //           top: 0,
  //           bottom: 0,
  //         },
  //       },
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       scales: {
  //         x: {
  //           grid: {
  //             display: false,
  //           },
  //         },
  //         y: {
  //           grid: {
  //             display: false,
  //           },
  //         },
  //       },
  //       onClick: (event, elements) => handleBarClick(event, elements),
  //       elements: {
  //         bar: {
  //           borderColor: '#494F55', // Set border color for bars
  //           borderWidth: 1, // Set border width for bars
  //         },
  //       },
  // };

  const options = {
    scales: {
        x: {
            title: {
                display: true,
                text: 'Month',
            },
            barPercentage: 0.2, // Adjust the value to decrease or increase the gap between bars
            categoryPercentage: 0.2, // Adjust the value to decrease or increase the gap between bars
            grid: {
                display: false,
            },
        },
        y: {
            title: {
                display: true,
                text: 'Vehicle Count',
            },
            beginAtZero: true,
            grid: {
                display: false,
            },
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        datalabels: {
            color: '#fff', // color of the data labels
            anchor: 'end', // position of the data labels
            align: 'start', // alignment of the data labels
            font: {
                weight: 'bold', // make the text bold
            },
        },
    },
    elements: {
        line: {
            tension: 0,
        },
    },
    layout: {
        padding: {
            left: 10,
            right: 10,
            top: 0,
            bottom: 0,
        },
    },
    maintainAspectRatio: false,
    responsive: true,
    onClick: (event, elements) => handleBarClick(event, elements),
    elements: {
        bar: {
            borderColor: '#494F55', // Set border color for bars
            borderWidth: 1, // Set border width for bars
        },
    },
};


    
  const handleBarClick = (event, elements) => {
    if(topping === 'CurrImb'){
    if (elements.length > 0) {
      const barIndex = elements[0].index;
      const label = labels[barIndex];
      setClickedDate(label)
      fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos_fleet/critcal_popuptable", body: { filterdata: gloablfilter, datelabel:label} }, popup_responce)
    }
  }};

  const popup_responce = (data) =>{
    setPopupData(data);
    window.$('#popuptable').modal('show');
  }

  return (
    <>
        <div className="chargingChartboxNew2_Kratos">
          <div className="v-title chargingTitleChart_Kratos_fleet">
          <div className="row p-0">
          <div className="col-md-5 ">
            {/* <div className="text-fit">Month on Month Analysis</div> */}
            <div className="text-fit" style={{ fontSize: '11px' }}>Month Analysis(Curr Imb)</div>
          </div>
          <div className="col-md-7 py-1" >
            <div className="form-check form-check-inline kratos" style={{ fontSize: '11px' }}>
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="CurrImb"
                value="CurrImb"
                checked={topping === "CurrImb"}
                onChange={toppingChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
              {/* Curr Imb vehicle count */}
              Vehicle count
              </label>
            </div>
            <div className="form-check form-check-inline kratos" style={{ fontSize: '11px' }}>
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="PercTopping"
                value="PercTopping"
                checked={topping === "PercTopping"}
                onChange={toppingChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
              {/* Percentage of Curr Imb vehicle */}
              Percentage count
              </label>
            </div>
          </div>
        </div>
          </div>

          <div className="tableContent_Kratos px-2 mt-4" style={{ height: '248px' }}>
            <WaterMark />
            {
            (finalBarData.length > 0) ?
            <Bar data={data} options={options} type={'bar'} plugins={[ChartDataLabels]}/> 
            : <NoData />
            }
          </div>
        </div>
        <div className="modal fade" id={"popuptable"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Data for: {clickedDate}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <CommanBarTable_Kratos data={popupData} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
